import { render, staticRenderFns } from "./PreSelfScorecard.vue?vue&type=template&id=57a02bec&scoped=true&"
import script from "./PreSelfScorecard.vue?vue&type=script&lang=js&"
export * from "./PreSelfScorecard.vue?vue&type=script&lang=js&"
import style0 from "./PreSelfScorecard.vue?vue&type=style&index=0&id=57a02bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a02bec",
  null
  
)

export default component.exports